import React from 'react';
import { Player } from './classes/Player';
import { RoundPhase } from './constants/RoundPhase';
import { Popups } from './constants/Popups';

interface GameHeaderInterface {
    players: Player[];
    isHost: boolean;
    roundPhase: RoundPhase;
    popup: Popups;
    openEndExitGameDialog: any;
    openRulesDialog: any;
    refresh: any;
    openRemovePlayerDialog: any;
}

function GameHeader({players, isHost, roundPhase, popup, openEndExitGameDialog, openRulesDialog, refresh, openRemovePlayerDialog}: GameHeaderInterface) {
    const rules = require("./images/rules.png");
    const refreshIcon = require("./images/refresh.png");
    const removePlayer = require("./images/removePlayer.png");
    const removePlayerBlack = require("./images/removePlayerBlack.png");

    const handleOpenEndExitGameDialog = () => {
        openEndExitGameDialog()
    }

    const handleOpenRulesDialog = () => {
        openRulesDialog()
    }

    const handleRefresh = () => {
        refresh()
    }

    const handleOpenRemovePlayerDialog = () => {
        openRemovePlayerDialog()
    }

    return (
        <div className="gameHeaderWrapper" style={{backgroundColor: `${roundPhase === RoundPhase.playBlackCard || roundPhase === RoundPhase.lookAtPlayedCards ? "#D30000" : "black"}`}}>
            <div className="gameHeaderEndGame" tabIndex={0} onClick={handleOpenEndExitGameDialog} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleOpenEndExitGameDialog();
                    }
                }}>{isHost ? "End Game" : "Exit Game"}</div>
            <div className="gameHeaderIconsWrapper">
                {roundPhase !== RoundPhase.playBlackCard && roundPhase !== RoundPhase.lookAtPlayedCards &&
                    <div className="gameHeaderRulesIcon" tabIndex={0} onClick={handleOpenRulesDialog} onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleOpenRulesDialog();
                        }
                    }}>
                        <img className="gameHeaderIcon" src={rules} alt="rules"/>
                    </div>
                }
                <div className="gameHeaderRefreshIcon" tabIndex={0} onClick={handleRefresh} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleRefresh();
                    }
                }}>
                    <img className="gameHeaderIcon" src={refreshIcon} alt="refresh"/>
                </div>
                {isHost && players.length > 1 &&
                    <div className="gameHeaderRemovePlayerIcon" tabIndex={0} onClick={handleOpenRemovePlayerDialog} onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleOpenRemovePlayerDialog();
                        }
                    }}>
                        <img className="gameHeaderIcon" src={roundPhase === RoundPhase.playBlackCard || roundPhase === RoundPhase.lookAtPlayedCards ? removePlayerBlack : removePlayer} alt="removePlayer"/>
                    </div>
                }
            </div>
        </div>
    );
};

export default GameHeader;